// SummaryCards.tsx

import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import type { CobranzasCampaignResponse } from "../../types";

interface SummaryCardsProps {
  data: CobranzasCampaignResponse;
}

export const SummaryCards = ({ data }: SummaryCardsProps) => {
  const count =
    typeof data.count === "number" ? data.count.toLocaleString() : "—";
  const tiempo =
    typeof data.tiempo_total_ms === "number"
      ? `${(data.tiempo_total_ms / 1000).toFixed(1)} s`
      : "—";

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <SummaryCard
          icon={<ContactsOutlinedIcon color="primary" />}
          label="Contactos"
          value={count}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <SummaryCard
          icon={<TimerOutlinedIcon color="primary" />}
          label="Tiempo de consulta"
          value={tiempo}
        />
      </Grid>
    </Grid>
  );
};

interface SummaryCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

const SummaryCard = ({ icon, label, value }: SummaryCardProps) => {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, height: "100%" }}>
      <CardContent>
        <Stack spacing={1}>
          {icon}
          <Typography variant="h5" fontWeight={700}>
            {value}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SummaryCards;
